module.exports = {
  name: 'Português (Brasil)',
  key: 'pt-BR',
  'Open in Debug Map': 'Abrir no Depurador de Mapa',
  'Open in Mapillary': 'Abrir em Mapillary',
  'GPX': 'Exportar arquivo GPX',
  'Open in editor': 'Abrir no editor',
  'Open in JOSM': 'Abrir no JOSM',
  'Select language': 'Selecione a linguagem',
  'Share Route': 'Compartilhar rota',
  'Link': 'Link',
  'Shortlink': 'Link curto',
  'Start - press enter to drop marker': 'Início - pressione enter para posicionar o marcador',
  'End - press enter to drop marker': 'Fim - pressione enter para posicionar o marcador',
  'Via point - press enter to drop marker': 'Via point - pressione enter para posicionar o marcador',
  'Build': 'Build: '
};
